import React from 'react';
import {useLocation} from 'react-router-dom';
import {ForecastQueryRenderer} from '../../ForecastQueryRenderer';
import InitialPlanPage, {InitialPlanPageQuery} from './InitialPlanPage';
import {VERSION_PARAM} from '../baseline/versions/useSelectedBaselineVersion';
import {hasFeatureFlag} from '../../forecast-app/shared/util/FeatureUtil';
import {FEATURE_FLAGS} from '../../constants';

/**
 * Loads the Baseline page. A `?version=<id>` in the URL loads that Baseline version's rows. The API answers an id
 * it cannot serve (a typo, another project's version, a deleted version, or a viewer who cannot read versions) with
 * the live rows, and the page tells which it got from the version list in the same response. While the versions
 * flag is off the URL's version is ignored and the query carries no version variable, exactly as before versions
 * existed. Only Standard loads without an id: the page removes Standard's id from the URL while Standard is active,
 * and adds the active version's id to a URL with none when that version is not Standard, so it loads its own rows.
 */
export const BaselineQueryRoute = ({match}: {match: {params: Record<string, string>}}): JSX.Element => {
	const {search} = useLocation();
	const versionsOn = hasFeatureFlag(FEATURE_FLAGS.BASELINE_VERSIONS);
	const baselineVersionId = new URLSearchParams(search).get(VERSION_PARAM);
	return (
		<ForecastQueryRenderer
			key={'query-render-projectInitialPlan' + match.params.projectId}
			query={InitialPlanPageQuery}
			variables={versionsOn ? {...match.params, baselineVersionId, versionsEnabled: true} : {...match.params}}
			requireProject={true}
			authorizeAccessRoute={'project-initial-plan'}
			fetchPolicy={'network-only'}
			render={(relayProps, retry) => <InitialPlanPage {...relayProps} retry={retry} />}
		/>
	);
};
